'use strict';

var _ = require('lodash');
var DowGroupController = function DowGroupController($scope, DowConstants, DowGroup) {
  $scope.getAllDaysDOW = function () {
    var allIds = _.clone(DowConstants.ALL_DOW_IDS);
    $scope.calendar.dowGroups = [new DowGroup({
      days: allIds
    })];
  };
  $scope.getEachDayDOW = function () {
    $scope.calendar.dowGroups = DowConstants.ALL_DOW_IDS.map(function (id) {
      return new DowGroup({
        days: [id]
      });
    });
    $scope.isCustomClicked = false;
    $scope.calendar.customDow = false;
  };
  $scope.allDays = function () {
    $scope.getAllDaysDOW();
    $scope.isCustomClicked = false;
    $scope.calendar.customDow = false;
  };
  $scope.isDowDisabled = function (last) {
    return !$scope.calendar.customDow || !last;
  };
  $scope.custom = function () {
    $scope.getAllDaysDOW();
    $scope.isCustomClicked = true;
    $scope.calendar.customDow = true;
  };
  $scope.getSelectedDays = function () {
    var daysOfWeekSelected = [];
    _.forEach($scope.calendar.dowGroups, function (group) {
      daysOfWeekSelected = _.union(group.days, daysOfWeekSelected);
    });
    return daysOfWeekSelected;
  };
  $scope.getRemainingDays = function () {
    var daysOfWeekSelected = $scope.getSelectedDays();
    var daysOfWeek = _.keys(DowConstants.ID_TO_NAME);
    var remainingDays = [];
    _.forEach(daysOfWeek, function (day) {
      if (daysOfWeekSelected.indexOf(day) === -1) {
        remainingDays.push(day);
      }
    });
    return remainingDays;
  };
  $scope.addDayOfWeekRow = function () {
    var remainingDays = $scope.getRemainingDays();
    var disabledDays = $scope.getSelectedDays();
    var dowGroup = new DowGroup({
      days: remainingDays,
      disabledDays: disabledDays
    });
    $scope.calendar.dowGroups.push(dowGroup);
  };
  $scope.showAddIcon = function (isLast) {
    var remainingDay = $scope.getRemainingDays();
    return $scope.calendar.customDow && remainingDay && remainingDay.length > 0 && remainingDay.length !== 7 && isLast;
  };
  $scope.$watch('calendar.dowGroups', function () {
    if ($scope.calendar.customDow && $scope.calendar.dowGroups && $scope.calendar.dowGroups.length > 1) {
      _.forEach($scope.calendar.dowGroups, function (group, index) {
        if (group && (!group.days || group.days.length === 0)) {
          $scope.calendar.dowGroups.splice(index, 1);
        }
      });
    }
  }, true);
};
DowGroupController.$inject = ['$scope', 'DowConstants', 'DowGroupFactory'];
module.exports = DowGroupController;